import { WalletOutlined, WifiOutlined, DollarCircleOutlined, FileDoneOutlined, CreditCardOutlined, FundProjectionScreenOutlined } from '@ant-design/icons';

const finance = {
  id: 'group-finance',
  title: 'Finance',
  type: 'group',
  children: [
    {
      id: 'wallet',
      title: 'Wallet',
      type: 'collapse',
      icon: WalletOutlined,
      children: [
        {
          id: 'wallet-overview',
          title: 'Overview',
          type: 'item',
          url: '/finance/wallet',
          icon: WalletOutlined
        },
        {
          id: 'wallet-top-up',
          title: 'Top Up',
          type: 'item',
          url: '/finance/wallet/top-up',
          icon: CreditCardOutlined
        }
      ]
    },
    {
      id: 'budget-utilization',
      title: 'Budget Utilization',
      type: 'item',
      url: '/finance/budget-utilization',
      icon: FundProjectionScreenOutlined
    }
    /*
    {
      id: 'airtime',
      title: 'Airtime',
      type: 'item',
      url: '/finance/airtime',
      icon: WifiOutlined
    },
    {
      id: 'b2c-mpesa',
      title: 'B2C M-Pesa',
      type: 'item',
      url: '/finance/b2c-mpesa',
      icon: DollarCircleOutlined
    },
    {
      id: 'payment-reports',
      title: 'Payment Reports',
      type: 'item',
      url: '/finance/payment-reports',
      icon: FileDoneOutlined
    },
   
    {
      id: 'payments-legacy',
      title: 'Payments (Legacy)',
      type: 'item',
      url: '/finance/payments-legacy',
      icon: CreditCardOutlined
    }
       */
  ]
};

export default finance;
